import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  BaseWidgetProperties,
  NotificationSettings,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
})
export class ToggleSwitchComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  @Input() public widgetConfigData: BaseWidgetProperties;
  @Input() public contentStyle: baseCssConfigStyle;
  @Input() public textContentStyle: baseCssConfigStyle;
  @Input() public iconStyle?: baseCssConfigStyle;
  @Input() public notificationSettings?: NotificationSettings;
  @Input() public widgetSettingsPropertyName: string;
  @Input() public showToggleSwitch = true;
  @Input() public checkedValue: boolean;
  @Input() public isDisabled?: boolean;
  @Output() valueChangeEmit: EventEmitter<boolean> = new EventEmitter();
  public renderedContent: string;
  public isWorkflow: boolean;
  constructor(
    private store: Store,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    private configService: ConfigService,
  ) {}

  ngOnInit() {
    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
    const content = this.widgetConfigData?.textContent;
    const template = Handlebars.compile(content);
    buildHandleBarModel(this.store, content, this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.renderedContent = template(model);
      });
  }

  public onChangeValueUpdate(event: boolean) {
    this.valueChangeEmit.emit(event);
  }

  public onComponentClick() {
    if (!this.showToggleSwitch) {
      this.valueChangeEmit.emit(!this.checkedValue);
    }
  }
}
